import React from 'react';
import PropTypes from 'prop-types';

import { Input, Button, Icon } from '../../ui-kit';
import './styles.scss';

const AuthView = (props) => (
  <div className="auth_page__wrapper">
    <div className="auth_page__modal__container">
      <div className="modal_window__container">
        <div className="modal_window__input__group">
          <p className="modal_window__title">Please log in</p>
          <div
            onBlur={() => props.setFocusEmail(false)}
            onFocus={() => { props.setFocusEmail(true); props.setErrorValue(); }}
            className={`modal_window__input 
              ${props.loading ? 'disable' : ''} 
              ${props.focusEmail ? 'active' : ''}`}
          >
            <Icon name="user" />
            <Input
              disabled={props.loading}
              value={props.email}
              type="email"
              onChange={(e) => props.setEmail(e.target.value)}
              label="Email"
            />
          </div>
          <div
            onBlur={() => props.setFocusPassword(false)}
            onFocus={() => { props.setFocusPassword(true); props.setErrorValue(); }}
            className={`modal_window__input 
              ${props.loading ? 'disable' : ''}
              ${props.focusPassword ? 'active' : ''}`}
          >
            <Icon styles={{ position: 'relative', bottom: '0.125em' }} name="shield" />
            <Input
              disabled={props.loading}
              maxLength={16}
              type="password"
              value={props.password}
              onChange={(e) => props.setPassword(e.target.value)}
              label="Password"
            />
          </div>
          {props.error ? (
            <div className="modal_window__errors">
              <span>
                {props.error}
              </span>
            </div>
          ) : null}
          <div className="modal_window__button__group">
            <Button
              disabled={props.disabled}
              loading={props.loading}
              onClick={() => props.handleAuth(props.email, props.password)}
              loaderColor="light"
              type="primary"
              value="Log in"
            />
          </div>
        </div>
      </div>
      <a
        className="easter_egg"
        target="_blank"
        rel="noopener noreferrer"
        href="https://tapston.com/"
      >
        Tapston Development
      </a>
    </div>
  </div>
);

AuthView.propTypes = {
  setEmail: PropTypes.func,
  setPassword: PropTypes.func,
  email: PropTypes.string,
  password: PropTypes.string,
  handleAuth: PropTypes.func,
  error: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  focusPassword: PropTypes.bool,
  setFocusPassword: PropTypes.func,
  setFocusEmail: PropTypes.func,
  focusEmail: PropTypes.bool,
  setErrorValue: PropTypes.bool,
};
AuthView.defaultProps = {
  setEmail: () => {},
  setPassword: () => {},
  handleAuth: () => {},
  setFocusPassword: () => {},
  setFocusEmail: () => {},
  setErrorValue: () => {},
  focusPassword: false,
  focusEmail: false,
  email: '',
  password: '',
  error: null,
  loading: false,
  disabled: false,
};

export default AuthView;
